// TUT-450 — dados de demonstração e importações (lotes do legado e importação comercial).
import { demoApi } from "../demo-data";
import type {
  ImportBatchListResponse,
  ImportBatchSummary,
  CommercialImportAcceptance,
  CommercialImportBatchDetail,
} from "../types";
import { DEMO_DATA_NO_NAVEGADOR, request } from "./infra";
import type { DemoDataState } from "./infra";

// Lido aqui, e não importado: o empacotador só dobra a constante no módulo
// que a escreve, e é isso que tira o demo do build de produção (TUT-448).
const useDemoApi = import.meta.env.VITE_API_MODE === "demo";

/**
 * TUT-472 — a carga inicial comercial não tem dublê no modo demonstração: o
 * parser e o aceite moram na API e gravam contratos, processos e tarefas de
 * verdade. Os três pedidos continuam indo à rede no demo DE PROPÓSITO — é o
 * caminho que `tests/e2e/commercial-initial-load.spec.ts` intercepta com
 * `page.route` para exercitar o painel inteiro. O que muda é a falha: sem API
 * atrás, a pessoa lia um erro de conexão; agora lê por que não há carga aqui.
 */
const CARGA_COMERCIAL_FORA_DA_DEMO =
  "A carga inicial de contratos e tarefas não está disponível na demonstração: ela grava dados de verdade no escritório.";

function cargaComercial<T>(pedido: () => Promise<T>): Promise<T> {
  if (!useDemoApi) return pedido();
  return pedido().catch(() => {
    throw new Error(CARGA_COMERCIAL_FORA_DA_DEMO);
  });
}

export const apiDaImportacao = {
  // TUT-303 — "Dados de demonstração". O modo demo do navegador já É a
  // demonstração: não há o que carregar, e a seção explica isso.
  demoDataState(): Promise<DemoDataState> {
    return useDemoApi
      ? Promise.resolve(DEMO_DATA_NO_NAVEGADOR)
      : request<DemoDataState>("/demo-data");
  },
  loadDemoData(): Promise<DemoDataState> {
    return useDemoApi
      ? Promise.resolve(DEMO_DATA_NO_NAVEGADOR)
      : request<DemoDataState>("/demo-data", { method: "POST" });
  },
  removeDemoData(): Promise<DemoDataState> {
    return useDemoApi
      ? Promise.resolve(DEMO_DATA_NO_NAVEGADOR)
      : request<DemoDataState>("/demo-data", { method: "DELETE" });
  },
  importBatches(): Promise<ImportBatchListResponse> {
    return useDemoApi
      ? demoApi.importBatches()
      : request<ImportBatchListResponse>("/import-batches");
  },
  acceptImportBatch(id: string): Promise<ImportBatchSummary> {
    return useDemoApi
      ? demoApi.acceptImportBatch(id)
      : request<ImportBatchSummary>(
          `/import-batches/${encodeURIComponent(id)}/accept`,
          { method: "POST" },
        );
  },
  commercialImportTemplate(): Promise<{ fileName: string; csvContent: string }> {
    return cargaComercial(() => request("/import-batches/commercial/template"));
  },
  dryRunCommercialImport(input: { label: string; csvContent: string }): Promise<CommercialImportBatchDetail> {
    return cargaComercial(() =>
      request("/import-batches/commercial/dry-run", {
        method: "POST",
        body: JSON.stringify(input),
      }),
    );
  },
  acceptCommercialImport(id: string, digest: string): Promise<CommercialImportAcceptance> {
    return cargaComercial(() =>
      request(`/import-batches/commercial/${encodeURIComponent(id)}/accept`, {
        method: "POST",
        body: JSON.stringify({ digest }),
      }),
    );
  },
};
